import * as PIXI from "pixi.js";
import {app, events, gameData, modal, ticker} from "../../utils/pixiApp";
import {shadowStyle, test, Tile} from "./Tile";
import {Prize} from "./Prize";
import {RecoverModalComponent} from "../modals/RecoverModalComponent";
import {Texture} from "pixi.js";
import TWEEN from "@tweenjs/tween.js";
import {getTileDeviceMedia} from "../../utils/sizes";

const sizes = {
    web: {
        tileMargin: 24,
        tileSize: 354
    },
    mobileSxx: {
        tileSize: 126,
        tileMargin: 8,
    },
    mobileSx: {
        // tileSize: 162,
        tileSize: 141,
        tileMargin: 8,
    },
    mobileSm: {
        // tileSize: 190,
        tileSize: 177,
        tileMargin: 16,
    },
    mobileXs: {
        tileSize: 220,
        tileMargin: 18,
    },
    mobileXxs: {
        tileSize: 250,
        tileMargin: 20,
    }
}

export class Body extends PIXI.Container{
    constructor() {
        super();
        this.TWEEN = TWEEN;
        ticker.add(() => this.TWEEN.update())
        this.mediaScreen = getTileDeviceMedia(app.screen.width)

        this.recoverGame = false

        this.activeBet = gameData.getGameData('activeBet')
        this.bets = [];
        this.tiles = [];
        this.openTiles = {}
        this.groupReveal = false
        this.doubleReval = []
        this.gamePrize;
        this.baseTextStyle = new PIXI.TextStyle({...test});

        events.onGameDataChange(this.onGameData.bind(this))
        events.onLoadApp(this.onLoadApp.bind(this))
        const rectw = this.mediaScreen === 'web' ? 3 : 2
        const recth = this.mediaScreen === 'web' ? 2 : 3
        this.rect = new PIXI.Rectangle(app.renderer.width / 2,app.renderer.height / 2,sizes[this.mediaScreen].tileSize * rectw + 36, sizes[this.mediaScreen].tileSize * recth + 18);
        this.position.set((app.renderer.width - (sizes[this.mediaScreen].tileSize * rectw + (sizes[this.mediaScreen].tileMargin * (rectw - 1)) )) / 2, (app.renderer.height - (sizes[this.mediaScreen].tileSize * recth + (sizes[this.mediaScreen].tileMargin * (rectw - 1)))) / 2)
        this.pivot.set(.5, .5)

        for (let i = 0; i < 6; i++) {
            const tile = new Tile();
            const mediaScreen = getTileDeviceMedia(app.screen.width)
            const scale = () => {
                switch (mediaScreen) {
                    case 'web':
                        return 1;
                    case 'mobileSx':
                        return .40;
                    case 'mobileSxx':
                        return .36
                    case 'mobileSm':
                        return .50;
                    case 'mobileXs':
                        return .62
                    default:
                        return .7
                }
            }
            const scaleSize = scale()
            tile.scale.set(scaleSize, scaleSize);
            const posX = ((sizes[this.mediaScreen].tileSize + sizes[this.mediaScreen].tileMargin) * (i % rectw));
            const posY = ((sizes[this.mediaScreen].tileSize + sizes[this.mediaScreen].tileMargin) * Math.floor(i / rectw))
            tile.position.set(posX, posY);
            tile.on('revealed', this.onTileRevealed.bind(this))
            this.tiles.push(tile)
            this.addChild(tile);
        }


        this.prize = new Prize(this.getBounds())
        this.addChild(this.prize)

        const a = this.children.filter(i => {
            console.log(i)
            return i !== this.prize
        })
        console.log(a)

        if(gameData.getGameData('recover')) {
            this.recoverGame = true
            this.outputBets = gameData.getGameData('outputBet')
            this.recover()
        }

        events.onScreenResizeEvent(() => {
            this.resizeView();
        })
    }

    resizeView() {
        const mediaScreen = getTileDeviceMedia(app.screen.width)
        const rectw = this.mediaScreen === 'web' ? 3 : 2
        const recth = this.mediaScreen === 'web' ? 2 : 3
        this.rect = new PIXI.Rectangle(app.renderer.width / 2,app.renderer.height / 2,sizes[this.mediaScreen].tileSize * rectw + 36, sizes[this.mediaScreen].tileSize * recth + 18);
        if(this.mediaScreen !== mediaScreen) {
            this.mediaScreen = mediaScreen

            if(mediaScreen === 'web') {
                this.position.set((app.renderer.width - (sizes[this.mediaScreen].tileSize * 3 + 36)) / 2, (app.renderer.height - (sizes[this.mediaScreen].tileSize * 2 + 68)) / 2)
                this.tiles.forEach((tile, i) => {
                    tile.scale.set(1,1)
                    const posX = ((sizes[this.mediaScreen].tileSize + sizes[this.mediaScreen].tileMargin) * (i % 3));
                    const posY = ((sizes[this.mediaScreen].tileSize + sizes[this.mediaScreen].tileMargin) * Math.floor(i / 3))
                    tile.position.set(posX, posY);
                })
            }
        } if (mediaScreen !== 'web') {
            this.position.set((app.renderer.width - (sizes[this.mediaScreen].tileSize * 2 + sizes[this.mediaScreen].tileMargin)) / 2, (app.renderer.height - (sizes[this.mediaScreen].tileSize * 3 + sizes[this.mediaScreen].tileMargin * 2)) / 2)
            this.tiles.forEach((tile, i) => {
                const scale = () => {
                    switch (mediaScreen) {
                        case 'mobileSx':
                            return .40;
                        case 'mobileSxx':
                            return .36
                        case 'mobileSm':
                            return .50;
                        case 'mobileXs':
                            return .62
                        default:
                            return .7
                    }
                }
                const scaleSize = scale()
                tile.scale.set(scaleSize, scaleSize);
                const posX = ((sizes[this.mediaScreen].tileSize + sizes[this.mediaScreen].tileMargin) * (i % 2));
                const posY = ((sizes[this.mediaScreen].tileSize + sizes[this.mediaScreen].tileMargin) * Math.floor(i / 2))
                tile.position.set(posX, posY);
            })
        }
        this.removeChild(this.prize)
        this.prize = new Prize(this.getBounds())
        this.addChild(this.prize)
        // this.prize.setSizes(this.rect.getBounds(), mediaScreen)
    }

    onLoadApp() {
        this.setData()
    }

    onGameData(eventArray) {
        if(eventArray.indexOf('bets') !== -1 || eventArray.indexOf('activeBet') !== -1) {
            this.setData()
        }
        if(eventArray.indexOf('startGame') !== -1) {
           this.startGame()
        }
        if(eventArray.indexOf('recover') !== -1) {
           this.recover()
        }
        if(eventArray.indexOf('speedUp') !== -1) {
            if(gameData.getGameData('speedUp')) {
                this.groupReveal = true
                this.tiles.forEach((tile) => {
                    if(tile.eventMode !== 'none') {
                        tile.emit('REVAL_TILE')
                    }
                })
            }
        }
    }

    startGame() {
        this.recoverGame = false;
        this.openTiles = {}
        const tilesBet = gameData.getGameData('tilesBet')
        this.outputBets = gameData.getGameData('outputBet')
        this.gamePrize = gameData.getGameData('prize')
        this.tiles.forEach((tile, idx) => {
            const texture = tilesBet.findIndex(item => item === this.outputBets[idx]) + 1 || 1
            tile.emit('START_TILE', {bet: this.outputBets[idx], tileTexture: String(texture)})
        })
    }

    recover() {
        //TODO: recover tile status
        // const tilesBet = gameData.getGameData('tilesBet')
        // gameData.setGameData('wasStarted', true)
        // this.groupReveal = true
        // this.tiles.forEach((tile, idx) => {
        //     const texture = tilesBet.findIndex(item => item === this.outputBets[idx]) + 1 || 10
        //     tile.emit('START_TILE', {bet: this.outputBets[idx], tileTexture: this.textures[texture]})
        // })
        // this.tiles.forEach((tile) => {
        //     tile.emit('REVAL_TILE')
        // })

        events.onLoadApp(this.onLoadRecover.bind(this))
    }

    setData() {
        this.bets = [];
        this.activeBet = gameData.getGameData('activeBet')
        this.tilesBet = gameData.getGameData('bets').get(this.activeBet)
    }

    onLoadRecover() {
        modal.onEmitIsOpenEvent(true, new RecoverModalComponent)
    }

    isThereTileRemaining() {
        return this.tiles.filter((x) => x.eventMode !== 'none').length > 0;
    }

    onTileRevealed(t) {
        const childTiles = this.children.filter(i => {
            return i !== this.prize
        })
        this.setOpenTiles(t.count)
        if(this.openTiles[t.count] >= 3) {
            this.doubleReval = [t.count]
            this.setOverlap(t.count, 3)
            if(!this.groupReveal) {
                this.tiles.forEach((tile) => {
                    if(tile.eventMode !== 'none') {
                        tile.emit('REVAL_TILE')
                    }
                })
            }
        }
        if(this.openTiles[t.count] === 2) {
            if(!this.groupReveal) {
                this.doubleReval.push(t.count)
                this.setOverlap(t.count, 2)
            }
        }
        if(!this.isThereTileRemaining() && gameData.getGameData('startGame')) {
            if(gameData.getGameData('prize') === 0) {
                this.tiles.forEach((tile) => {
                    tile.text.style = this.baseTextStyle
                    tile.border.texture = Texture.from('tileRect')
                })
            }
            gameData.setGameData('startGame', false)
            gameData.setGameDataByEvent('gameOver', true)
            this.groupReveal = false
            this.doubleReval = []
        }
    }

    setOpenTiles(tileCount) {
        if(tileCount in this.openTiles) {
            this.openTiles[tileCount] += 1
        } else {
            this.openTiles[tileCount] = 1
        }
    }

    setOverlap(count, num) {
        if(num === 3) {
            let prizeTiles = []
            this.tiles.forEach((t, idx) => {
                if(t.count === count) {
                    prizeTiles.push(idx)
                    t.text.style = {...test, ...{fill: '#ffd99f', fontSize: 124, dropShadowColor: "#030f17", stroke: "#C5833E",strokeThickness: 6, dropShadowDistance: 5, dropShadowAngle: 0.4, fontWeight: 700, lineHeight: 200}}
                    if(t.border.texture !== Texture.from('tileRectPrize')) {
                        t.border.texture = Texture.from('tileRectPrize')
                    }
                    t.startFire()
                } else {
                    t.text.style = this.baseTextStyle
                    if(t.border.texture !== Texture.from('tileRectPrize')) {
                        t.border.texture = Texture.from('tileRect')
                    }
                }
            })
            const textAnim = new this.TWEEN.Tween({sizePrize: 124, size: 96}).to({sizePrize: 152, size: 124}, 700).onUpdate(obj => {
                prizeTiles.forEach(pt => {
                    this.tiles[pt].text.style.fontSize = obj.sizePrize
                })
            }).yoyo(true).repeat(3)

            textAnim.start()
            return
        } else {
            let animTiles = []
            this.tiles.forEach((tile, idx) => {
                if(this.doubleReval.findIndex(i => i === tile.count) === 0 && tile.eventMode === 'none') {
                    if(tile.text.style.fill !== '#ffd99f') {
                        tile.text.style = new PIXI.TextStyle({...test, ...{fill: '#ffd99f'}, ...shadowStyle})
                        tile.border.texture = Texture.from('tileRectActive1')
                    }
                    if(this.doubleReval.length === 1) {
                        animTiles.push(idx)
                    }
                    return
                }
                if(this.doubleReval.findIndex(i => i === tile.count) === 1 && tile.eventMode === 'none') {
                    if(tile.text.style.fill !== '#ffffff') {
                        tile.text.style = new PIXI.TextStyle({...test, ...{fill: '#ffffff'}})
                        tile.border.texture = Texture.from('tileRectActive2')
                    }
                    animTiles.push(idx)
                } else {
                    if(tile.text.style.fill !== '#dce5e9') {
                        tile.text.style = new PIXI.TextStyle({...test, ...{fill: '#dce5e9'}})
                    }
                    if(tile.border.texture !== Texture.from('tileRect')) {
                        tile.border.texture = Texture.from('tileRect')
                    }
                }
            })
            let c = 0;
            Object.keys(this.openTiles).forEach(i => {c += this.openTiles[i]})
            if(c < 6) {
                const arr = [].concat(animTiles)
                const textAnim = new this.TWEEN.Tween({size: 96}).to({size: 114}, 500).onUpdate(obj => {
                    arr.forEach(at => {
                        this.tiles[at].text.style.fontSize = obj.size
                    })
                }).yoyo(true).repeat(1);
                textAnim.start()
            }
        }
    }
}